import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UI_ROUTES } from 'src/app/app.contant';
import { AuthService } from 'src/app/modules/core/services/auth/auth.service';
import { BUTTON_DATA } from 'src/app/modules/shared/models';
import { qesService } from 'src/app/modules/shared/services/qes/qes.service';

@Component({
  selector: 'app-qes-approve-reject',
  templateUrl: './qes-approve-reject.component.html',
  styleUrls: ['./qes-approve-reject.component.scss']
})
export class QESApproveRejectComponent implements OnInit {
  prDetails?: any;
  public remarks!: string;
  public statusForm!: FormGroup;
  public buttonData!: Array<any>;
  public rawApprovalList!:any;
  public readonly ROUTES = UI_ROUTES;

  constructor(
    public bsModalRef: BsModalRef,
    public _qesService: qesService,
    private _authServie: AuthService,
    private _formBuilder: FormBuilder,
    private _toastrService : ToastrService,
    private _router: Router,
    private _loaderService : NgxUiLoaderService) {
      this.statusForm = this._formBuilder.group({
        remarks : [null, []]
      });
     }

  ngOnInit(): void {
  }

  public updateQESStatus(status: string) {
    const qesNo = this._qesService.getqesNoValue();
    if(this.rawApprovalList.length) {
      this.rawApprovalList[0].approval_status = status;
      this.rawApprovalList[0].approver_comments = this.statusForm.getRawValue().remarks;
      const body = {
        "approvals_details" : this.rawApprovalList[0]
      }
      this._qesService.updateQesDetailsByApproverId(body, qesNo?.qes_no).subscribe((approverList: any) => {
        this.bsModalRef.hide();
        this._router.navigate([`${this.ROUTES.HOME}`]);
      }, (err: any) => {
      });
    } else {

    }
  }

}
